/**
 * Perfused volume ID generation.
 *
 * Uses nanoid to produce unique, collision-resistant IDs with a `pv_` prefix.
 * This ensures two identical PV definitions always receive distinct identifiers.
 */

import { nanoid } from 'nanoid';

const PV_PREFIX = 'pv_';
const NANOID_LENGTH = 12;

/** Generate a unique perfused volume ID (e.g. `pv_V1StGXR8_Z5j`). */
export function generatePvId(): string {
    return `${PV_PREFIX}${nanoid(NANOID_LENGTH)}`;
}
